import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import {
  QuestionListItemNumberUi,
  QuestionListItemTitle,
  QuestionListItemUi,
} from './ui'

type QuestionListProps = {
  number: number
  title: string
  children: React.ReactNode
  select: () => void
}

export const QuestionList = ({
  number,
  title,
  children,
  select,
}: QuestionListProps) => {
  const { t } = useTypedTranslation()
  return (
    <QuestionListItemUi>
      <QuestionListItemNumberUi>{number}.</QuestionListItemNumberUi>
      <QuestionListItemTitle
        onClick={select}
        placeholder={t(
          'entity_settings.survey.question_edit.title_placeholder',
        )}
      >
        {title}
      </QuestionListItemTitle>
      {children}
    </QuestionListItemUi>
  )
}
